import { type FormEvent, useState } from "react";
import { CASE_REGISTRY } from "../case/registry";
import { IconAgencia } from "../ui/icons";
import styles from "./shell.module.css";

/**
 * Login-credencial (os §1) sobre el fondo generado del puerto: la pantalla
 * de meta-progresión ES el login, con tile de usuario como un OS de 2011.
 * F0: rango fijo "Aprendiz", 0 sellos (los reales llegan con F1-T04).
 * El expediente asignado se elige acá; cada caso guarda su propia partida.
 */

interface Props {
  initialName: string;
  initialCaseId: string;
  onLogin: (name: string, caseId: string) => void;
}

export function Login({ initialName, initialCaseId, onLogin }: Props) {
  const [name, setName] = useState(initialName);
  const [caseId, setCaseId] = useState(initialCaseId);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (trimmed.length > 0) onLogin(trimmed, caseId);
  };

  return (
    <div className={styles.loginScreen}>
      <form className={styles.credential} onSubmit={submit} data-testid="login">
        <div className={styles.credentialCrest} aria-hidden="true">
          <IconAgencia size={40} />
        </div>
        <p className={styles.credentialAgency}>LA AGENCIA · VERIFICACIÓN E INDAGACIONES</p>
        <h1 className={styles.credentialTitle}>Credencial de acceso</h1>

        <div className={styles.userTile}>
          <span className={styles.userAvatar} aria-hidden="true">
            {name.trim() ? name.trim()[0]?.toUpperCase() : "?"}
          </span>
          <div className={styles.userFields}>
            <label className={styles.credentialLabel} htmlFor="detective-name">
              Verificador externo
            </label>
            <input
              id="detective-name"
              className={styles.credentialInput}
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Nombre y apellido"
              autoComplete="off"
              data-testid="login-name"
              // biome-ignore lint/a11y/noAutofocus: pantalla unipropósito — el foco directo ES la navegación por teclado
              autoFocus
            />
          </div>
        </div>

        <dl className={styles.credentialMeta}>
          <div>
            <dt>Rango</dt>
            <dd>Aprendiz</dd>
          </div>
          <div>
            <dt>Sellos</dt>
            <dd>—</dd>
          </div>
          <div className={styles.credentialCaseField}>
            <dt>
              <label htmlFor="case-select">Expediente</label>
            </dt>
            <dd>
              <select
                id="case-select"
                className={styles.caseSelect}
                value={caseId}
                onChange={(e) => setCaseId(e.target.value)}
                data-testid="login-case"
              >
                {CASE_REGISTRY.map((k) => (
                  <option key={k.id} value={k.id}>
                    {k.title}
                  </option>
                ))}
              </select>
            </dd>
          </div>
        </dl>

        <button
          type="submit"
          className={styles.credentialSubmit}
          disabled={name.trim().length === 0}
          data-testid="login-submit"
        >
          Abrir expediente
        </button>
      </form>
    </div>
  );
}
